export default Object.freeze({
	CONTRACTORS: 'Contractors',
	APPRENTICES: 'Apprentices',
	ASBESTOS_WORKER: 'asbestosWorkers',
});
